<template lang="pug">
  v-layout(row justify-center)
    v-flex(xs12)
      v-card-title
        v-btn(icon)
          v-icon(large color="primary" @click="$router.go(-1)") arrow_back
        h3 Отчетность
        v-btn(icon @click="openModal")
          v-icon(large color="primary") help_outline
      v-card-text
        v-layout(row justify-center class="px-4")
          v-flex(xs12 class="mx-2")
            span.upperLine Выберете отчет
            v-select(
              flat,
              solo,
              :items="eventList",
              item-text="title",
              item-value="id",
              v-model="selectEvent",
              placeholder="Выберете отчет",
              no-data-text="К сожалению ничего нет :(")
        v-layout(row justify-center class="px-4")
          v-flex(sm4 class="mx-2")
            span.upperLine Выберете район
            v-select(
              flat,
              solo,
              :items="districts",
              v-model="selectDistrict",
              placeholder="Выберете район",
              no-data-text="К сожалению ничего нет :(")
          v-flex(sm3 class="mx-2")
            span.upperLine Период с:
            v-menu(
              ref="menu"
              :close-on-content-click="false",
              v-model="menu1",
              min-width="290px",
              full-width)
              v-text-field(
                slot="activator",
                v-model="dateFrom",
                single-line,
                solo,
                flat,
                placeholder="Период c:")
              v-date-picker(
                no-title
                scrollable
                ref="picker"
                locale="ru"
                v-model="dateFrom"
                @input="menu1 = false")
          v-flex(sm3 class="mx-2")
            span.upperLine Период по:
            v-menu(
              ref="menu"
              :close-on-content-click="false",
              v-model="menu2",
              min-width="290px",
              full-width)
              v-text-field(
                slot="activator",
                v-model="dateTo",
                single-line,
                solo,
                flat,
                placeholder="Период по:")
              v-date-picker(
                no-title
                scrollable
                ref="picker"
                locale="ru"
                v-model="dateTo"
                @input="menu2 = false")
          v-flex(sm2 class="mx-2")
            v-btn(color="success", block,  @click="show", class="btn") Показать
        v-divider
      v-layout(justify-center).pb-4
        v-flex(xs11)
          pie-chart(v-if="loading", :chartData="pieChartData", :options="pieChartOptions", :height="parseInt('500')")
          ReportTable(v-if="isTable", :title="tableTitle")
      InfoPopup(:isVisibleModal="isShowModal", id="report", name="Отчетность",  @close-info-popup="closeModal")
</template>

<script>
import PieChart from '../Chartsjs/PieChart'
import data from '../Chartsjs/data.json'
import ReportTable from './ReportTable/ReportTable'
import InfoPopup from '../DataBase/Common/InfoPopup'
export default {
  name: 'Reports',
  components: { InfoPopup, ReportTable, PieChart },
  data: () => ({
    eventList: [],
    districts: [
      'Ак-Суйский район',
      'Ак-Талинский район',
      'Аксыйский район',
      'Ала-Букинский район',
      'Алайский район',
      'Аламудунский район',
      'Араванский район',
      'Ат-Башынский район',
      'Базар-Коргонский район',
      'Бакай-Атинский район',
      'Балыкчы',
      'Баткен',
      'Баткенский район',
      'Джалал-Абад',
      'Жайылский район',
      'Жети-Огузский район',
      'Жумгальский район',
      'Иссык-Кульский район',
      'Кадамжайский район',
      'Кара-Бууринский район',
      'Кара-Кулжинский район',
      'Кара-Сууский район',
      'Каракол',
      'Кеминский район',
      'Кок-Жангак',
      'Кочкорский район',
      'Лейлекский район',
      'Ленинский район',
      'Манасский район',
      'Московский район',
      'Нарын',
      'Нарынский район',
      'Ноокатский район',
      'Ноокенский район',
      'Октябрьский район',
      'Панфиловский район',
      'Первомайский район',
      'Свердловский район',
      'Сокулукский район',
      'Сузакский район',
      'Талас',
      'Таласский район',
      'Тогуз-Тороуский район',
      'Токмок',
      'Токтогульский район',
      'Тонский район',
      'Тюпский район',
      'Узгенский район',
      'Чаткальский район',
      'Чон-Алайский район',
      'Чуйский район',
      'Ысык-Атинский район'
    ],
    pieChartData: {
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: [
            '#F34336',
            '#E81D63',
            '#9B25AF',
            '#673AB6',
            '#3F51B4',
            '#2195F2',
            '#02A8F3',
            '#01BBD3',
            '#019387',
            '#4CAE4F',
            '#8AC04B',
            '#CCDB3A',
            '#FFC009',
            '#FE9700',
            '#FE5723',
            '#9D9D9D'
          ],
          borderWidth: 4
        }
      ]
    },
    pieChartOptions: {
      maintainAspectRatio: false,
      aspectRatio: 4,
      legend: {
        position: 'bottom',
        labels: {
          fontSize: 14,
          fontColor: '#333',
          boxWidth: 20
        }
      },
      title: {
        display: true,
        text: '',
        fontSize: 24,
        fontColor: '#333',
        padding: 16
      }
    },
    selectEvent: '',
    selectDistrict: '',
    menu1: false,
    menu2: false,
    dateFrom: '',
    dateTo: '',
    loading: false,
    isTable: false,
    tableTitle: '',
    isShowModal: false
  }),
  mounted() {
    this.eventList = data
  },
  watch: {
    selectEvent(val) {
      this.loading = false
      this.isTable = false
      this.tableTitle = ''

      if (val) {
        data.filter(item => {
          if (val === 'table') {
            this.tableTitle = item.title
          }
          if (item.id === val) {
            this.pieChartData.labels = item.labels
            this.pieChartData.datasets[0].data = item.values
            this.pieChartOptions.title.text = item.title
          }
        })
      }
    }
  },
  methods: {
    openModal() {
      this.isShowModal = true
    },
    closeModal() {
      this.isShowModal = false
    },
    show() {
      this.tableTitle !== '' ? (this.isTable = true) : (this.loading = true)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  height: 46px;
  transform: translateY(15px);
  border-radius: 4px;
}
.upperLine {
  display: block;
  font-size: 0.82rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/Reports.vue